// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"fd91ff35","361":"18b6e123","511":"8d91d5aa","767":"c8b4fc1b"}[chunkId] + ".chunk.js";
};